import React from 'react';
import Search from './Search';
import HelpInfoTab from './helpInfo/HelpInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'
import * as Formatter from 'fw/components/formatter/Formatter';

class HelpSetup extends React.Component {
    render() {
        
        let opts = {
            title: "Help Topics",
            description: "Create, modify, and remove help pages",
            helpKey: Help.helpSetupHelpKey,
            recentType: "help",
            list: {
                url: API.App.url('/helpSetup/search'),
                rowKey: "helpTopicId",
                columns: [
                    { key: 'helpKey', name: 'Screen or Tab Location', sortable: false },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "helpInfo", title: "Help Info", comp: HelpInfoTab, helpKey: Help.helpSetupInfoHelpKey },
                { key: "helpAudit", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.helpSetupAuditHelpKey }
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default HelpSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/helpSetup/HelpSetup.js